const _ = require('@sigma-legacy-libs/no-lodash')

const { isSimpleObject } = require('../../validators')

function cleanSettingValue(value, schema) {
  if (typeof schema.$cleaner === 'function') {
    value = schema.$cleaner(value, schema)
  } else if (schema.$multiple) {
    if (Array.isArray(value)) {
      value = value.filter(index => ~schema.$options.findIndex(option => option.$value === index))
    } else {
      value = undefined
    }
  } else if (schema.$options && !~schema.$options.findIndex(option => option.$value === value)) {
    value = undefined
  }

  return value
}
function defaultSettingValue(value, schema) {
  if (value === undefined || isSimpleObject(value)) {
    if (typeof schema.$defaulter === 'function') {
      value = schema.$defaulter(value, schema)
    } else {
      value = schema.$default
    }
  }

  return value
}

function processSchemaKey(
  value, path, fullSchema, setDefault
) {
  const schema = fullSchema[path]

  if (!schema) {
    throw new Error('Invalid path')
  }

  let result = cleanSettingValue(value, schema)
  if (setDefault) {
    result = defaultSettingValue(result, schema)
  }

  return result
}

function processSchema(input, fullSchema, setDefaults) {
  if (!input || typeof input !== 'object') {
    input = {}
  }

  const result = {}

  for (const path in fullSchema) {
    const value = _.get(input, path, input[path])
    result[path] = processSchemaKey(
      value, path, fullSchema, setDefaults
    )
  }

  return result
}

exports.cleanSettingValue = cleanSettingValue
exports.defaultSettingValue = defaultSettingValue
exports.processSchemaKey = processSchemaKey
exports.processSchema = processSchema
